import React from "react";
import { connect } from "react-redux";
import { stateRights, customerTypeRights } from "../../../utils/statesUS";
import RightRow from "./RightRow";
import "./rightsTable.css";
import PropTypes from "prop-types";

const RightsTable = (props) => {
  const handleRights = () => {
    const stateSelected = props.requestForm.step?.supportedState;
    const customerRelationSelected = props.requestForm.step?.customerRelation;
    const brandSelected = props.requestForm.step?.brand;
    const onBehalfOf = props.requestForm.step?.onBehalfOf;
    const customerRights = customerTypeRights(
      stateSelected,
      customerRelationSelected,
      onBehalfOf,
      brandSelected
    );
    const rightsAvailable = stateRights[stateSelected];
    const finalRights = rightsAvailable.filter((r) =>
      customerRights.includes(r.rightType)
    );

    return finalRights?.map((right) => {
      const dataTestId = right.rightTitle.replace(/ /g, "_");
      return (
        <RightRow
          key={right.rightType}
          rightTitle={right.rightTitle}
          rightTitleKey={right.rightTitleKey}
          rightText={right.rightText}
          dataTestId={dataTestId}
          type={right.rightTitle}
          image={right.rightImage}
          disabled={right.disabled}
          showInfo={right.showInfo}
        />
      );
    });
  };

  return (
    <div id="rights-table">
      <div id="rights-table-rows">{handleRights()}</div>
    </div>
  );
};

RightsTable.propTypes = {
  requestForm: PropTypes.shape({
    step: PropTypes.shape({
      supportedState: PropTypes.string,
      customerRelation: PropTypes.string,
      brand: PropTypes.string,
      onBehalfOf: PropTypes.string,
    }),
  }).isRequired,
};

const mapStateToProps = (state) => {
  return {
    requestForm: state.requestForm,
  };
};

export default connect(mapStateToProps)(RightsTable);
